'use client';
import { useState } from 'react';

// Shown only for the "permission denied" geolocation error — walks the user
// through re-enabling location access, since the browser gives no way to
// re-trigger the native permission prompt once denied.
export const LocationPermissionHelp = () => {
    const [open, setOpen] = useState(false);

    return (
        <div style={{ marginTop: 4 }}>
            <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                style={{
                    background: 'none', border: 'none', padding: 0, cursor: 'pointer',
                    color: 'var(--primary-color)', fontSize: '0.72rem', fontWeight: 700,
                    display: 'flex', alignItems: 'center', gap: 4,
                }}
            >
                How do I enable it?
                <i className={`pi ${open ? 'pi-chevron-up' : 'pi-chevron-down'}`} style={{ fontSize: '0.6rem' }} />
            </button>

            {open && (
                <ol
                    style={{
                        margin: '6px 0 0', paddingLeft: '1.1rem',
                        fontSize: '0.72rem', color: 'var(--text-color-secondary)', lineHeight: 1.65,
                    }}
                >
                    <li>Tap the lock/info icon next to the website address in your browser's address bar.</li>
                    <li>Open <strong>Site settings</strong> (or <strong>Permissions</strong>).</li>
                    <li>Set <strong>Location</strong> to <strong>Allow</strong>.</li>
                    <li>Reload this page and try again.</li>
                </ol>
            )}
        </div>
    );
};
